import { useEffect } from "react";
import type { LiveExamSignal } from "../helpers/proethica-session-sync";
import {
	resolveAdoptableModuleSessions,
	resolveStaleTrackedModuleIds,
} from "../helpers/proethica-session-sync";
import { useProethicaSessionStore } from "./useProethicaSessionStore";

let lastSyncedDataUpdatedAt = 0;

export const useProethicaSessionSync = (
	exams: LiveExamSignal[] = [],
	dataUpdatedAt = 0,
) => {
	useEffect(() => {
		if (exams.length === 0 || dataUpdatedAt <= lastSyncedDataUpdatedAt) {
			return;
		}
		lastSyncedDataUpdatedAt = dataUpdatedAt;
		const { sessionByModule, clearModuleSessions, setModuleSession } =
			useProethicaSessionStore.getState();
		const staleModuleIds = resolveStaleTrackedModuleIds(
			sessionByModule,
			exams,
			dataUpdatedAt,
		);
		clearModuleSessions(staleModuleIds);
		for (const { moduleId, numericId } of resolveAdoptableModuleSessions(
			sessionByModule,
			exams,
			staleModuleIds,
		)) {
			setModuleSession(moduleId, { numericId });
		}
	}, [exams, dataUpdatedAt]);
};
